export const SoundType = {
	reminder: 'reminder',
	newMessage1: 'newMessage1',
	newMessage2: 'newMessage2',
	send: 'send',
	dialtone: 'dialtone',
	ringtone: 'ringtone',
	ringtoneModern: 'ringtoneModern',
	start: 'start',
	stop: 'stop',
	error: 'error',
};